@if (!loading) {
  <div class="signin-root" style="padding: 0 !important">
    <!-- Moving product images (hero) -->
    <div class="hero-wrapper mobile-only">
      <div class="hero-grid">
        @for (row of heroRows; track row; let i = $index) {
          <div class="hero-row" [ngClass]="'hero-row-' + i">
            @for (img of row; track img) {
              <div class="hero-item">
                <img [src]="img" alt="Product" loading="lazy" />
              </div>
            }
          </div>
        }
      </div>
      <!-- Optional back button (like Blinkit) -->
      <button class="back-btn" type="button" (click)="router.navigate(['/'])">
        <mat-icon>arrow_back</mat-icon>
      </button>
    </div>
    <!-- Login card -->
    <div class="card-wrapper" [class.in-dialog]="!!dialogRef">
      <div class="signin-card">
        @if (dialogRef) {
          <button class="dialog-close-btn" type="button" (click)="dialogRef.close()" title="Close">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#64748b" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        }
        <div class="card-decor"></div>
        <div class="logo-wrapper">
          <div class="logo-circle">
            <img [src]="logoSrc" alt="Logo" />
          </div>
        </div>
        <h1 class="title">Crafted for your home essentials</h1>
        <p class="subtitle">Log in or Sign up to start shopping</p>
        <form (ngSubmit)="onNext()" novalidate class="signin-form">
          <div class="form-field-group">
            <label class="phone-label" for="xcom_sign_in_page_phone_number">Enter mobile number</label>
            <div class="phone-input-wrapper">
              <div class="country-code-box">
                <span class="flag">🇮🇳</span>
                <span class="country-code">+91</span>
              </div>
              <div class="input-sep"></div>
              <input
                id="xcom_sign_in_page_phone_number"
                type="tel"
                maxlength="10"
                name="phone"
                [(ngModel)]="data.phoneNumber"
                class="phone-input"
                (keyup)="isMobValid()"
                placeholder="Enter mobile number"
                autocomplete="tel" />
              @if (isPhoneValid) {
                <div class="valid-icon-box">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#16a34a" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                </div>
              }
            </div>
          </div>
          <button
            type="submit"
            [disabled]="isLoading || !isPhoneValid"
            id="xcom_sign_in_page_sign_in_button"
            class="btn-continue"
            [ngClass]="{ 'btn-valid': isPhoneValid }">
            @if (!isLoading) {
              <span>Continue</span>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="btn-arrow">
                <line x1="5" y1="12" x2="19" y2="12"></line>
                <polyline points="12 5 19 12 12 19"></polyline>
              </svg>
            } @else {
              <mat-spinner [diameter]="22"></mat-spinner>
            }
          </button>
        </form>
        <p class="terms">
          By continuing, you agree to our
          <a href="/terms" target="_blank">Terms of Service</a>
          &
          <a href="/privacy" target="_blank">Privacy Policy</a>
        </p>
        <div class="signup-row">
          <span>Don’t have an account?</span>
          <button
            id="xcom_sign_in_page_sign_up_button"
            type="button"
            (click)="onSignup()"
            class="btn-signup">
            Sign up
          </button>
        </div>
      </div>
    </div>
  </div>
}
